module.exports = __webpack_public_path__ + "static/co-fes-logo-white@2x-01404c73bcf38761b27c00a60efdb32f.png";